import { useMemo } from 'react';
import {
  buildNeveredIngredientProductLookup,
  type NeveredIngredientProductLookup,
} from '../../utils/neveredIngredientProductLookup';
import { useCustomerNeveredIngredientProducts } from './useCustomerNeveredIngredientProducts';

/**
 * V12 Ingredient Dislikes → products that contain those ingredients.
 * Empty map when the customer has no dislikes or the query is disabled.
 */
export function useNeveredIngredientProductLookup(options?: {
  enabled?: boolean;
}): NeveredIngredientProductLookup {
  const { data } = useCustomerNeveredIngredientProducts(options);

  return useMemo(
    () => buildNeveredIngredientProductLookup(data?.results),
    [data?.results]
  );
}
